import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TooltipGlobalService } from './tooltip-global.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tooltip-global',
  imports: [CommonModule],
  templateUrl: './tooltip-global.component.html',
  styleUrl: './tooltip-global.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipGlobalComponent {
  constructor(public tooltip: TooltipGlobalService) {}
}
